module.exports = __webpack_public_path__ + "static/media/change-icon.50f55581.svg";